import styled from "styled-components";

export const WatermarkText = styled.h1`
  font-family: var(--font-bolden-van);
  font-size: 12px;
  color: #ffffff;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  font-weight: 900;
  line-height: 0;
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: black;
  text-shadow: 1px 1px 0 black;
  opacity: 0.5;
  padding: 0px 0px 0px 0px;
`;

export const Title1 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-bolden-van);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  color: ${(props) => (props.color !== "" ? props.color : "#ebce00")};
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: #945700;
  text-shadow:
    -1px -1px 0 #945700,
    1px -1px 0 #945700,
    -1px 1px 0 #945700,
    1px 1px 0 #945700;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title2 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-bolden-van);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
  text-shadow: 1px 1px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title3 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-ms-sans);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow: 2px 2px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title4 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-ravie);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title5 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-nerd);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title6 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-jakarta);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title7 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-thejacarta);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title8 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-burner);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
  text-transform: uppercase;
`;

export const Title9 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-impact);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 9000;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title10 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-lowpoly);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title11 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-ed);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title12 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-maxi);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 900;
  color: ${(props) => (props.color ? props.color : "white")};
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title13 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-clash);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : "white")};
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title14 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-inter);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 300;
  color: ${(props) => (props.color ? props.color : "white")};
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;

export const Title15 = styled.h1<{ fontSize?: number; color?: string }>`
  font-family: var(--font-inter);
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "1rem")};
  font-weight: 600;
  color: ${(props) => (props.color ? props.color : "white")};
  margin: 0;
  padding: 0;
  white-space: normal;
  width: 100%;
  word-break: break-word;
  text-align: center;
  line-height: ${(props) =>
    props.fontSize && props.fontSize < 48 ? "40px" : "1"};
`;
